<template>
  <div class="flex flex-column flex-grow-1 text-input" :class="`${AppConfig.theme}-theme`">
    <label class="label-top">{{ props.label }}</label>
    <p v-if="props.description" class="description">{{ props.description }}</p>
    <div class="p-float-label">
      <InputText v-model="model" v-bind="$attrs" :required="props.required" style="width: 100%"></InputText>
      <label class="label-border">{{ props.label }}</label>
    </div>
    <div class="flex">
      <small v-if="v$.value.$error" class="p-error">{{ props.label }} field has an error.</small>
      <small v-if="v$.value.$error == [] && props.required" id="nin_number-help" class="help-text"
        >*{{ t('general.required') }}</small
      >
    </div>
  </div>
</template>
<script setup>
import { ref, computed, reactive } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { useI18nUtils } from '@/composables/utils/useI18nUtils.js'
import AppConfig from '~/config/appConfig.js'

const props = defineProps({
  label: String,
  required: Boolean,
  description: String,
})

const model = defineModel()

const { t } = useI18nUtils()

const value = reactive(model)

const rules = computed(() => {
  const v = {}
  if (props.required) {
    v.value = { required }
  } else {
    v.value = {}
  }
  return v
})

const v$ = useVuelidate(rules, { value })
</script>

<style scoped>
input {
  height: 40px;
  box-shadow: 1px 2px 4px #00000029;
  border: 0.5px solid #E5E5E5;
  border-radius: 8px;
}

label {
  font-weight: 550;
  color: #013315;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
}

.label-top {
  margin-bottom: 8px;
  display: none;
}

.text-input .description{
  display: none
}

@media screen and (min-width: 768px) {
  .label-top, .text-input .description {
    display: block;
  }

  .label-border {
    display: none;
  }
}

.text-input .description {
  margin-bottom: 8px;
  font-size: 0.875rem;
  color: #484649;
}

.sbg-theme {
  label {
    color: rgba(0, 0, 0, 0.6);
    font-weight: normal;
    width: auto;
  }

  .label-top {
    display: none;
  }

  .label-border {
    display: block;
  }

  .p-focus ~ label {
    color: #00afa5;
  }

  input {
    border-radius: 8px;
    height: auto;
    line-height: normal;
    box-shadow: none;
    border: 1px solid rgba(0, 0, 0, 0.38);
  }
}

</style>
